import { useQuery } from "@tanstack/react-query";

import { getAllFeatureFlags } from "services";

import { DEFAULT_CACHE_TIME, GET_ALL_FEATURE_FLAGS } from "consts";

import { FeatureFlagsResponse } from "models";

// Currently only available for admins
export const useGetAllFeatureFlags = () =>
  useQuery<FeatureFlagsResponse[]>({
    queryKey: [GET_ALL_FEATURE_FLAGS],
    queryFn: getAllFeatureFlags,
    staleTime: DEFAULT_CACHE_TIME,
    gcTime: DEFAULT_CACHE_TIME,
  });
